export default {
    welcomeContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    titleText: {
        fontSize: '50px',
        margin: '15vh 0 5vh 0',
        fontWeight: 'bold',
        fontFamily: 'Roboto',
        '@media (max-width: 767px)': {
            margin: '12vh 10px 10vh 10px',
            fontSize: '2.3rem',
        }
    },
    startButtonContainer :{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    }
}